import React, { useEffect, useMemo, useRef, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ChevronDown } from "lucide-react";
import { ReactComponent as Tag } from "../../assets/images/Tag.svg";

function cx(...arr) {
  return arr.filter(Boolean).join(" ");
}

const OPTIONS = [
  { value: "", label: "สถานะ", pill: "" },
  { value: "พร้อมขาย", label: "พร้อมขาย", pill: "ready" },
  { value: "ไม่พร้อมขาย", label: "ไม่พร้อมขาย", pill: "notready" },
];

function Pill({ pill, label }) {
  if (!pill) return <span className="text-slate-700">{label}</span>;
  const cls =
    pill === "ready"
      ? "bg-green-100 text-green-700"
      : "bg-amber-100 text-amber-700";
  return (
    <span className={cx("inline-flex items-center rounded-full px-3 py-1 text-xs font-semibold", cls)}>
      {label}
    </span>
  );
}

export default function StatusSelect({ value, onChange }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  const selected = useMemo(() => OPTIONS.find((o) => o.value === value) || OPTIONS[0], [value]);

  useEffect(() => {
    const onDoc = (e) => {
      if (!ref.current) return;
      if (!ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", onDoc);
    return () => document.removeEventListener("mousedown", onDoc);
  }, []);

  return (
    <div ref={ref} className="relative">
      <button
        onClick={() => setOpen((v) => !v)}
        className={cx(
          "inline-flex items-center gap-2 rounded-xl border-2 border-[#E5E7EB] px-4 py-3 text-sm font-semibold",
          "hover:bg-[#EEEEEE] hover:border-[#EEEEEE] hover:text-[#047DED]"
        )}
      >
        <Tag width={20} height={20} className="hover:text-[#047DED]" />
        <span className="min-w-[72px] text-left">
          {selected.value ? <Pill pill={selected.pill} label={selected.label} /> : selected.label}
        </span>
        <ChevronDown size={18} className={cx("text-slate-600 transition", open && "rotate-180")} />
      </button>

      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ opacity: 0, y: 6, scale: 0.98 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 6, scale: 0.98 }}
            transition={{ duration: 0.16 }}
            className="absolute right-0 mt-2 w-[220px] overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-lg z-50"
          >
            {OPTIONS.map((o) => (
              <button
                key={o.value || "__all"}
                onClick={() => {
                  onChange?.(o.value);
                  setOpen(false);
                }}
                className={cx(
                  "w-full px-4 py-3 text-left text-sm hover:bg-slate-900/5 transition flex items-center justify-between",
                  value === o.value && "bg-blue-600/5"
                )}
              >
                <span className="font-medium text-slate-700">{o.label === "สถานะ" ? "ทั้งหมด" : o.label}</span>
                {o.value ? <Pill pill={o.pill} label={o.label} /> : null}
              </button>
            ))}
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}
